module.exports = __webpack_public_path__ + "static/media/setting-tokenActive.27d2019e.svg";